// --- Vendors ---------------

import 'lodash';
import SockJS from 'sockjs-client';
window.SockJS = SockJS;
// --- Angular --------------

import 'angular/angular.js';
import ngMessages from 'angular-messages';
import ngAnimate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import ngCookies from 'angular-cookies';
import 'angular-base64/angular-base64';
import toaster from 'angularjs-toaster';
import ngstorage from 'ngstorage-webpack';
import ngIdle from 'ng-idle';

// --- Angular plugins ------

import angularUiRouter from 'angular-ui-router';
import angularUiBootstrap from 'angular-ui-bootstrap';
import angularUiNotification from 'angular-ui-notification';
import 'angular-ui-notification/dist/angular-ui-notification.css';
import 'angular-busy/dist/angular-busy.css';
require('angular-busy');

require('angular-wizard');
import 'angular-wizard/dist/angular-wizard.css';
require('angular-xeditable');
import 'angular-xeditable/dist/css/xeditable.css';

import gettext from 'angular-gettext';
import './po/he.po';
import './po/it.po';
import './po/es.po';
import './po/el.po';
import './po/fr.po';
import './po/tr.po';
import './po/da.po';
import './po/de.po';
import './po/de_DE.po';
import './po/bg.po';
import './po/et.po';
import './po/hu.po';
import './po/ro.po';
import './po/sk.po';
import './po/cs.po';
import './po/nn.po';
import './po/sv.po';
import './po/id.po';
import './po/tr.po';
import deferredBootstrapper from 'angular-deferred-bootstrap';

require('babel-polyfill');
import "babel-polyfill";


import 'bootstrap-css-only';

// --- Application ----------------

import './styles.less';
import './theme-styles.less';
import 'angularjs-toaster/toaster.css';
const moment = require('angular-moment');
import MomentTimeZone from 'moment-timezone';
window.MomentTimeZone = MomentTimeZone;

import MainModule from './main';
import GuestModule from './guest';

import ServicesModule from './services';
import ComponentsModule from './components';
import DirectivesModule from './directives';
import * as appVersion from './version.json';


const firebase = require("firebase/app");
require("firebase/messaging");
const config = {
    apiKey: "AIzaSyA9H-jseVqYnBhKRB4T3LTzERai4A_yWmc",
    authDomain: "personal-page-f7a10.firebaseapp.com",
    databaseURL: "https://personal-page-f7a10.firebaseio.com",
    projectId: "personal-page-f7a10",
    storageBucket: "",
    messagingSenderId: "127070734102"
};
firebase.initializeApp(config);

// --- Translations ----------------


deferredBootstrapper.bootstrap({
    element: document.body,
    module: 'app',
    bootstrapConfig: {
        strictDi: true
    },
    resolve: {
        APP_CONFIG: ['$http', function ($http) {
            return $http.get('/config/config.json')
                .then(resp => resp.data)
                .catch(err => ({}));
        }],
        LANGUAGE: ['$http', function ($http) {
            return $http.get('https://api.sscr.secominteractive.com/general/language/')
                .then(resp => resp.data.languages[0])
                .catch(err => ({}));
        }]
    }
});


export default angular.module('app',
    [
        ngMessages,
        ngAnimate,
        ngSanitize,
        ngCookies,
        'base64',
        angularUiRouter,
        angularUiBootstrap,
        angularUiNotification,
        'xeditable',
        'cgBusy',

        //App Modules
        MainModule,
        GuestModule,

        // App Components
        ComponentsModule,

        DirectivesModule,

        // App Services
        ServicesModule,
        'mgo-angular-wizard',
        'angularMoment',
        gettext,
        toaster,
        ngstorage,
        ngIdle,

    ])
    .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$locationProvider',
        ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider) => {
            $urlRouterProvider.otherwise("/main/panels");
        }]
    )
    .config(
        ['KeepaliveProvider', 'IdleProvider', (KeepaliveProvider, IdleProvider) => {
            IdleProvider.idle(240);
            IdleProvider.timeout(60);
            KeepaliveProvider.interval(240);
        }]
    )
    .constant('version', appVersion)
    .filter('humanize', [() => {
        return (val) => {
            return _.capitalize(_.kebabCase(val).replace(/-/g, ' '));
        }
    }])
    .run(['$rootScope', '$state', 'editableOptions', 'gettextCatalog', 'ApiAccountService', '$localStorage',
        'LanguageService', 'LANGUAGE', 'Idle',
        ($rootScope, $state, editableOptions, gettextCatalog, ApiAccountService, $localStorage,
                  LanguageService, LANGUAGE, Idle,) => {

            Idle.watch();
            if($state.$current.name.concat('login') == 'login')
            {
                document.body.style.backgroundColor = 'white';
            }
            editableOptions.theme = 'bs3'; // bootstrap3 theme
            $rootScope.$on('loginrequired', () => $state.go('login'));

            if ($localStorage.language) {
                LanguageService.setLanguageByShortcut($localStorage.language);
            }
            else {
                LanguageService.setLanguageByShortcut(LANGUAGE);
            }

            // gettextCatalog.setCurrentLanguage('ro');
            // gettextCatalog.debug = true;
            // gettextCatalog.debugPrefix = '[M]:';
            // gettextCatalog.showTranslatedMarkers = true;

            try {
                const messaging = firebase.messaging();
                messaging.requestPermission()
                    .then(() => {
                        // console.log('Notification permission granted.');
                        messaging.getToken()
                            .then((currentToken) => {
                                if (currentToken) {
                                    ApiAccountService.saveEndPointToken(currentToken);
                                    ApiAccountService.setEndPoint();

                                } else {
                                    // console.log('No Instance ID token available. Request permission to generate one.');
                                }
                            })
                            .catch((err) => {
                                // console.log('An error occurred while retrieving token. ', err);
                            });
                    });
                messaging.onMessage((payload) => {
                    // console.log('onMessage:', payload);
                    // if(payload.hasOwnProperty('notification')) {
                    //     if(payload.data.msg_type == '2') {
                    //         var audio = new Audio(panicAudio);
                    //         audio.play();
                    //     }
                    //     $rootScope.$broadcast('notification', payload);
                    // }
                    // else{
                    //     $rootScope.$broadcast('dataNotification', payload);
                    // }
                });

                messaging.onTokenRefresh(() => {
                    messaging.getToken()
                        .then((refreshedToken) => {
                            // console.log('Token refreshed.', refreshedToken);
                            ApiAccountService.saveEndPointToken(refreshedToken);
                            ApiAccountService.setEndPoint();
                            // Indicate that the new Instance ID token has not yet been sent to the
                            // app server.
                        })
                        .catch((err) => {
                            // console.log('Unable to retrieve refreshed token ', err);
                        });
                });
            }
            catch (err) {
            }

            // $rootScope.$on('$stateChangeStart', () => {
            //     $rootScope.$broadcast('userAction')
            //     console.log('$stateChangeStart')
            //
            // });

        }])
    .directive('numbersOnly', () => {
        return {
            require: 'ngModel',
            link: (scope, element, attrs, modelCtrl) => {
                modelCtrl.$parsers.push((inputValue) => {
                    // this next if is necessary for when using ng-required on your input.
                    // In such cases, when a letter is typed first, this parser will be called
                    // again, and the 2nd time, the value will be undefined
                    if (inputValue == undefined || inputValue == null) return '';
                    let transformedInput = inputValue.replace(/[^0-9]/g, '');
                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };
    })
    .filter('isEmptyObject', [function() {
      return function(object) {
        return angular.equals({}, object);
      }
    }])
    .constant("VERSION", {number: '1.0.0.1', name: ''});


/** WEBPACK FOOTER **
 ** ./src/app.js
 **/